import React from "react"
import { Container } from "react-responsive-grid"
import { rhythm, scale } from "../utils/typography"
import IndexLayout from './index';
import Header from './Header';
import Footer from './Footer';


class PageLayout extends React.Component {
  render() {
    return (
      <div>
        <div style={{background: '#FBFBFB', borderBottom: '1px solid #eaeaea'}}><Container
          style={{
            maxWidth: rhythm(35),
            padding: `${rhythm(0.5)} ${rhythm(3 / 4)}`,
          }}
          >
          <Header />
        </Container></div>

        <Container
          style={{
            maxWidth: rhythm(35),
            padding: `${rhythm(0.5)} ${rhythm(3 / 4)}`
          }}
        >
          {this.props.children()}
        </Container>

        <Footer />
      </div>
    )
  }
}

PageLayout.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/layouts/page.js